import { math } from '@galacean/effects';

export const {
  Vector2, Vector3, Vector4, Matrix3, Matrix4, Color, Euler, EulerOrder, Quaternion,
  Box3, Sphere, Ray, DEG2RAD,
} = math;

export type Ray = math.Ray;
export type Euler = math.Euler;
export type Vector2 = math.Vector2;
export type Vector3 = math.Vector3;
export type Vector4 = math.Vector4;
export type Matrix3 = math.Matrix3;
export type Matrix4 = math.Matrix4;
export type Color = math.Color;
export type Quaternion = math.Quaternion;
